import axios from 'axios'
import * as querystring from 'querystring'

import config from '../config/urlConfig'
import formatAxiosError from '../util/formatAxiosError'
import axiosOptions from '../const/axios-options'
import { GetList } from '../models/HinhAnhGallery'

export default class GalleryService {

    /**
     * @author Bình
     * lấy danh sách gallery theo danh mục
     */

    static search(
      limit: number = 10,
      page = 1,
      searchObject: any = {}
  ): Promise<any> {
      let body = Object.assign({}, searchObject, {
          per_page: limit,
          page: page
      });
      return axios
          .post(`${config.app.api}/api/gallery/search`, body, axiosOptions)
          .then(response => {
              return response.data
          })
  }
    static getList(
        danhMucId: number,
        loai = "h",
        page = 1,
        perPage = 1
      ): Promise<GetList> {
        return axios
          .post(`${config.app.api}/api/gallery/search`, {
            danh_muc_id: danhMucId,
            loai: loai,
            page: page,
            per_page: perPage
          }, axiosOptions)
          .then(response => {
            return response.data;
          })
          .catch(error => {
            let formatedError = formatAxiosError(error);
            throw formatedError;
          });
      }

    /**
     * @author Bình
     * lấy thông tin 1 gallery theo gallery_id
     */
    static getone(gallery_id) {
        let query = querystring.stringify({ gallery_id: gallery_id })

        return axios
            .get(`${config.app.api}/api/gallery/getone?${query}`, axiosOptions)
            .then(response => {
                return response.data.result
            })
    }

    /**
     * @author Bình
     * get gallery liên quan theo gallery_id và loại
     */
    static getsLienQuanByIDAndLoai(
        gallery_id: number,
        loai: number,
        limit: number = 10
    ): Promise<any> {
        return axios
            .post(`${config.app.api}/api/gallery/gets-lien-quan-by-gallery-loai`, {
                gallery_id: gallery_id,
                loai: loai,
                limit: limit
            }, axiosOptions)
            .then(response => {
                return response.data
            })
    }

}